import { FC, Dispatch, useState, useEffect } from "react";
import {
  BytesToReadableSize,
  FormatDateFE,
} from "../../../helper/general/methods";
import { UserDecisionInterface } from "../../../middleware/interfaces/user/user-decision-interface";
import { UserInterface } from "../../../middleware/interfaces/user/user-interface";
import { ReportInterface } from "../../../middleware/interfaces/report/report-interface";
import { ReportDeleteInterface } from "../../../middleware/interfaces/report/report-delete-interface";
import { ReportDownloadInterface } from "../../../middleware/interfaces/report/report-download-interface";
import { ReportRetrieveInterface } from "../../../middleware/interfaces/report/report-retrieve-interface";
import { ReportDescriptionRetrieveInterface } from "../../../middleware/interfaces/report/report-description-retrieve-interface";
import MenuButton from "../user/menu-button";
interface reportInfoProps {
  user: UserInterface;
  selectedReport: ReportInterface;
  setSelectedReport: Dispatch<any>;
  dispatch: Dispatch<any>;
}

const ReportInfo: FC<reportInfoProps> = ({
  user,
  selectedReport,
  setSelectedReport,
  dispatch,
}) => {
  const [openReport, setOpenReport] = useState(false);
  const [deleteReportDialogReveal, setDeleteReportDialogReveal] =
    useState(false);
  const [downloadReport, setDownloadReport] = useState(false);
  const [retrieveReportDescription, setRetrieveReportDescription] =
    useState(false);

  useEffect(() => {
    if (openReport === true) {
      const openReportData: ReportRetrieveInterface = {
        email: user.email,
        reportID: selectedReport.reportID,
        projectID: user.openProject?.projectID!,
        type: "ReportRetrieveInterface",
      };
      dispatch({
        type: "RETRIEVE_REPORT",
        payload: openReportData,
      });
      setOpenReport(false);
      setSelectedReport(null);
    }
  }, [openReport]);

  useEffect(() => {
    if (deleteReportDialogReveal) {
      const reportDeleteData: ReportDeleteInterface = {
        email: user.email,
        reportID: selectedReport.reportID,
        projectID: user.openProject?.projectID!,
        projectUserRole: user.openProject?.projectUserRole!,
        type: "ReportDeleteInterface",
      };
      const decision: UserDecisionInterface = {
        title: `Delete ${selectedReport.reportName}?`,
        message:
          "The report and every note on it will be removed. This cannot be undone.",
        confirmLabel: "Delete",
        decisionOptions: ["DELETE_REPORT", "NO_ACTION"],
        result: "",
        data: reportDeleteData,
        type: "UserDecisionInterface",
      };
      dispatch({ type: "DECISION", decision: decision });
    }
    setDeleteReportDialogReveal(false);
  }, [deleteReportDialogReveal]);

  useEffect(() => {
    if (retrieveReportDescription === true) {
      const reportRetrieveDescriptionData: ReportDescriptionRetrieveInterface =
        {
          reportID: selectedReport.reportID,
          type: "ReportDescriptionRetrieveInterface",
        };
      dispatch({
        type: "RETRIEVE_REPORT_DESCRIPTION",
        payload: reportRetrieveDescriptionData,
      });
      setRetrieveReportDescription(false);
    }
  }, [retrieveReportDescription]);

  useEffect(() => {
    if (downloadReport === true) {
      const downloadReportData: ReportDownloadInterface = {
        email: user.email,
        reportID: selectedReport.reportID,
        projectID: user.openProject?.projectID!,
        projectUserRole: user.openProject?.projectUserRole!,
        type: "ReportDownloadInterface",
      };
      const decision: UserDecisionInterface = {
        title: `Download ${selectedReport.reportName}?`,
        message: "The report is prepared and saved to your computer.",
        confirmLabel: "Download",
        decisionOptions: ["DOWNLOAD_REPORT", "NO_ACTION"],
        result: "",
        data: downloadReportData,
        type: "UserDecisionInterface",
      };
      dispatch({ type: "DECISION", decision: decision });
    }
    setDownloadReport(false);
  }, [downloadReport]);

  return (
    <>
      {(() => {
        if (selectedReport) {
          return (
            <div className="itemDetails">
              <div className="itemDetailsHeader">
                <img
                  className="icon-medium"
                  src="assets/icons/report.png"
                  draggable="false"
                  alt={selectedReport.reportName}
                />
                <div className="itemDetailsIdentity">
                  <span className="itemDetailsName">
                    {selectedReport.reportName}
                  </span>
                  <span className="itemDetailsSubtitle">
                    Report · {BytesToReadableSize(selectedReport.reportSize)}
                  </span>
                </div>
                <span
                  className="itemDetailsClose"
                  onClick={() => {
                    setSelectedReport(null);
                  }}
                >
                  ×
                </span>
              </div>
              <div className="itemDetailsMetadata">
                <span className="itemDetailsLabel">CLASHES</span>
                <span className="itemDetailsValue">
                  {selectedReport.reportClashCount}
                </span>
                <span className="itemDetailsLabel">CREATED</span>
                <span className="itemDetailsValue">
                  {FormatDateFE(selectedReport.reportCreationDate!, true)}
                </span>
                <span className="itemDetailsLabel">BY</span>
                <span className="itemDetailsValue">
                  {selectedReport.reportUploadedBy}
                </span>
              </div>
              <div className="itemDetailsActions">
                <MenuButton
                  imageSource="assets/icons/view-report.png"
                  alternativeText="View report"
                  buttonSize="small"
                  buttonAccent="primary"
                  dispatch={() => {
                    setOpenReport(true);
                  }}
                />
                <MenuButton
                  imageSource="assets/icons/write-text.png"
                  alternativeText="Description"
                  buttonSize="small"
                  dispatch={() => {
                    setRetrieveReportDescription(true);
                  }}
                />
                <MenuButton
                  imageSource="assets/icons/download.png"
                  alternativeText="Download"
                  buttonSize="small"
                  dispatch={() => {
                    setDownloadReport(true);
                  }}
                />
                {user.openProject?.projectUserRole !== "USER" ? (
                  <MenuButton
                    imageSource="assets/icons/delete.png"
                    alternativeText="Delete"
                    buttonSize="small"
                    buttonAccent="destructive"
                    dispatch={() => {
                      setDeleteReportDialogReveal(true);
                    }}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          );
        } else {
          return <></>;
        }
      })()}
    </>
  );
};

export default ReportInfo;
